function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Immutable from 'seamless-immutable';
import { Configurable } from 'invision-core';
import { ORDER_ACCESS, SUBSCRIBER_CREATE, ADDRESS_ACCESS } from '../../security.attributes';

/*
    Global Action Data Structure:
        id - Required: This ID should be generated in invision-core to ensure it remains the same across the app
        securityAttributes - Optional: The security attributes are run through the PermissionsService.hasAccess function,
            if any of the attributes are not met, then the action is not added to the collection
        adminAttributes - Optional: The security attributes are run through PermissionsService.hasAdminAccess function
*/

var CUSTOMER_GLOBAL_ACTIONS_IDS = Configurable.CustomerCare.CUSTOMER_GLOBAL_ACTIONS_IDS;
export var CREATE_COMMERCIAL_CUSTOMER_GLOBAL_ACTION = {
  id: CUSTOMER_GLOBAL_ACTIONS_IDS.CREATE_COMMERCIAL_CUSTOMER,
  glyph: 'building',
  securityAttributes: [SUBSCRIBER_CREATE]
};
export var CREATE_CUSTOMER_GLOBAL_ACTION = {
  id: CUSTOMER_GLOBAL_ACTIONS_IDS.CREATE_CUSTOMER,
  glyph: 'user',
  securityAttributes: [SUBSCRIBER_CREATE]
};
export var CREATE_RESIDENTIAL_CUSTOMER_GLOBAL_ACTION = {
  id: CUSTOMER_GLOBAL_ACTIONS_IDS.CREATE_RESIDENTIAL_CUSTOMER,
  glyph: 'user',
  securityAttributes: [SUBSCRIBER_CREATE]
};
export var GUEST_CHECKOUT_GLOBAL_ACTION = {
  id: CUSTOMER_GLOBAL_ACTIONS_IDS.GUEST_CHECKOUT,
  glyph: 'shopping-cart',
  securityAttributes: [ORDER_ACCESS]
};
export var NEW_CONNECT_GLOBAL_ACTION = {
  id: CUSTOMER_GLOBAL_ACTIONS_IDS.NEW_CONNECT,
  glyph: 'shopping-cart',
  securityAttributes: [ORDER_ACCESS],
  adminAttributes: [ADDRESS_ACCESS]
};
export var GLOBAL_ACTIONS_MAP = Immutable(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, CREATE_COMMERCIAL_CUSTOMER_GLOBAL_ACTION.id, CREATE_COMMERCIAL_CUSTOMER_GLOBAL_ACTION), CREATE_CUSTOMER_GLOBAL_ACTION.id, CREATE_CUSTOMER_GLOBAL_ACTION), CREATE_RESIDENTIAL_CUSTOMER_GLOBAL_ACTION.id, CREATE_RESIDENTIAL_CUSTOMER_GLOBAL_ACTION), GUEST_CHECKOUT_GLOBAL_ACTION.id, GUEST_CHECKOUT_GLOBAL_ACTION), NEW_CONNECT_GLOBAL_ACTION.id, NEW_CONNECT_GLOBAL_ACTION));